export default {
  methods: {
    getStatutNF(value) {
      let statut = '';
      switch (value) {
        case 0:
          statut = 'En attente de validation';
          break;
        case 1:
          statut = 'Validé';
          break;
        case 2:
          statut = 'Refusé';
          break;
      }
      return statut;
    },
  },
};
